import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from 'lib-trend-core';
import { ResetPasswordComponent } from './reset-password.component';

@NgModule({
  imports: [
    CommonModule,           
    SharedModule,
    
  ],
  declarations: [
    ResetPasswordComponent    
  ],
  exports: [
    ResetPasswordComponent         
  ],
})
export class ResetPasswordModule { }
